import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Select from "react-select"
import { bindActionCreators } from "redux"
import { sendInvites } from "../../../redux/api/organizations"

const InviteNewUsers = ({ onBack, roles, sendInvites }) => {
  const [membersToInvite, setMembersToInvite] = useState([{ name: "", email: "", role_id: "" }])
  const [isSending, setIsSending] = useState(false)
  const addRow = () => {
    setMembersToInvite([...membersToInvite, { name: "", email: "", role_id: "" }])
  }
  const update = (index, field, value) => {
    const updatedMembers = membersToInvite.map((member, i) => {
      if (i === index) {
        return { ...member, [field]: value }
      }
      return member
    })
    setMembersToInvite(updatedMembers)
  }
  const removeRow = index => {
    const updatedMembers = membersToInvite.filter((_, i) => i !== index)
    setMembersToInvite(updatedMembers)
  }
  return (
    <div>
      <div className='col-12'>
        {membersToInvite.map((invite, i) => (
          <div key={i} className='flex mb2 pb2 border-bottom border-gray-4'>
            <div className='col-4 pr1'>
              <label className='cs-label' htmlFor={`invite_name_${i}`}>
                Name
              </label>
              <input
                id={`invite_name_${i}`}
                placeholder='First and last name'
                className='cs-input col-12'
                value={invite.name}
                onChange={e => update(i, "name", e.target.value)}/>
            </div>
            <div className='col-4 px1'>
              <label className='cs-label' htmlFor={`invite_email_${i}`}>
                Email
              </label>
              <input
                id={`invite_email_${i}`}
                placeholder='Enter email address'
                className='cs-input col-12'
                value={invite.email}
                onChange={e => update(i, "email", e.target.value)}/>
            </div>
            <div className={`${i > 0 ? "flex-auto" : "col-4"} pl1`}>
              <label className='cs-label'>Role</label>
              <Select
                options={roles.map(role => ({
                  value: role._id,
                  label: role.name
                }))}
                value={invite.role_id}
                clearable={false}
                className={`col-12 no-min-width`}
                onChange={e => update(i, "role_id", e.value)}/>
            </div>
            {i > 0 && (
              <div className='pl1' style={{ paddingTop: "22px" }}>
                <button className='cs-button link tooltip' data-tooltip='Remove' onClick={() => removeRow(i)}>
                  <i className='material-icons'>delete</i>
                </button>
              </div>
            )}
          </div>
        ))}
        <div className='col-12 mb2'>
          <button className='cs-button white small' onClick={addRow}>
            Invite another team member
          </button>
        </div>
        <div className='flex justify-end'>
          <button className='cs-button white' onClick={onBack}>Back</button>
          <button
            className='cs-button ml1'
            disabled={isSending || (membersToInvite.filter((member) => member.role_id === '').length > 0)}
            onClick={() => {
              setIsSending(true)
              sendInvites(membersToInvite)
            }}
          >
            {isSending ? "Sending..." : "Send invite"}
          </button>
        </div>
      </div>
    </div>
  )
}

InviteNewUsers.propTypes = {
  onBack: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
  roles: state.settings.organizations.roles.items,
})

const mapDispatchToProps = dispatch => ({
  sendInvites: bindActionCreators(sendInvites, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(InviteNewUsers)